var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.844,
    height: 25.554,
    viewBox: "0 0 20.844 25.554",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#34366d;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.777,2H6.355A2.355,2.355,0,0,0,4,4.355V23.2a2.355,2.355,0,0,0,2.355,2.355H20.488A2.355,2.355,0,0,0,22.844,23.2V9.066Z",
    transform: "translate(-4 -2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14,2V9.066h7.066",
    transform: "translate(-2.222 -2)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 9.662,
    transform: "translate(4.768 12.943)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 9.662,
    transform: "translate(4.768 17.402)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.355,9H8",
    transform: "translate(-3.289 -0.756)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileText);
export default __webpack_public_path__ + "static/media/file-text.53ed6a7e6d5e3d39846c547608657035.svg";
export { ForwardRef as ReactComponent };